import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from 'store';
import { useRouter } from 'next/router';
import Link from 'next/link';

import groupClasses from 'utils/groupClasses';
import {
  NavBar,
  Logo,
  Right,
  AccountSection,
  MobileNav,
  MobileNavLeft,
  MobileNavRight,
  HamburgerToggle,
  NavItem,
} from './styles';
import AccountMenu from './AccountMenu';
import MobileMenu from './MobileMenu';

const Navigation = () => {
  const {
    rootStore: { dashboardStore, classDetailsStore, giftsStore },
  } = useStore();

  const router = useRouter();
  const [mobileMenuOpen, toggleMobileMenu] = useState(false);

  const validUser =
    (classDetailsStore.activeClass && classDetailsStore.activeClass.userType !== 'previewer') ||
    dashboardStore.loaded ||
    giftsStore.loaded;

  const classes = dashboardStore.libraryAccess
    ? dashboardStore.classesToUnlock
    : dashboardStore.classesToPurchase;
  const classMap = groupClasses(classes || []);

  const isHCC = classDetailsStore.isHCC && router.pathname.includes('classes/[slug]');

  return (
    <>
      <NavBar hcc={isHCC}>
        <div>
          <Link href="/user/classes">
            <a href="/user/classes" title="Dashboard" aria-label="Classes Dashboard">
              <Logo isHCC={isHCC} />
            </a>
          </Link>
          <Right>
            <NavItem href="https://www.mindbodygreen.com/" aria-label="Read">
              Read
            </NavItem>
            <NavItem href="https://institute.mindbodygreen.com/" aria-label="Learn">
              Learn
            </NavItem>
            <NavItem href="https://shop.mindbodygreen.com/" aria-label="Shop">
              Shop
            </NavItem>
            <NavItem href="https://www.mindbodygreen.com/podcasts" aria-label="Listen">
              Listen
            </NavItem>
            <AccountSection>
              <AccountMenu isLoggedIn={validUser} />
            </AccountSection>
          </Right>
        </div>

        <MobileNav>
          <MobileNavLeft>
            <HamburgerToggle
              type="button"
              open={mobileMenuOpen}
              onClick={() => toggleMobileMenu(!mobileMenuOpen)}
              aria-label="Toggle Menu"
            >
              <span />
              <span />
              <span />
            </HamburgerToggle>
          </MobileNavLeft>
          <Link href="/user/classes" passHref>
            {/* eslint-disable */}
            <a title="Dashboard" aria-label="Dashboard">
              <Logo />
            </a>
            {/* eslint-enable */}
          </Link>
          <MobileNavRight />
        </MobileNav>
      </NavBar>
      {mobileMenuOpen ? (
        <MobileMenu
          categories={Object.keys(classMap)}
          toggleMenu={() => toggleMobileMenu(!mobileMenuOpen)}
        />
      ) : null}
    </>
  );
};

export default observer(Navigation);
